import { ILinkItem, client_selected } from "../client";
import { ERole } from "../interfaces/User/newUser";

const navbarLinksDefault = client_selected.navbarLinksDefault;

const navbarLinksAnalyst = client_selected.navbarLinksAnalyst;

const navbarLinksClient = client_selected.navbarLinksClient;

// const rolePriorityMap: Record<string, number> = {
//   Admin: 3,
//   Analista: 2,
//   Cliente: 1,
// };

// export const navbarLinks = (profiles: IProfile[] | undefined): ILinkItem[] => {
//   if (!profiles || profiles.length === 0) {
//     return navbarLinksDefault;
//   }
//   const roles = profiles.map((profile) => profile.name.trim());
//   const highestRole = roles.reduce((highest, current) => {
//     const currentPriority = rolePriorityMap[current] || 0;
//     const highestPriority = rolePriorityMap[highest] || 0;
//     return currentPriority > highestPriority ? current : highest;
//   }, "");

//   switch (highestRole) {
//     // case "Admin":
//     //   return navbarLinksAdmin;
//     case "Analista":
//       return navbarLinksAnalyst;
//     case "Cliente":
//       return navbarLinksClient;
//     default:
//       return navbarLinksDefault;
//   }
// };
export const navbarLinks = (role: ERole | null): ILinkItem[] => {
  switch (role) {
    // case "Admin":
    //   return navbarLinksAdmin;
    case "Analista":
      return navbarLinksAnalyst;
    case "Cliente":
      return navbarLinksClient;
    default:
      return navbarLinksDefault;
  }
};
